module.exports = __webpack_public_path__ + "img/glodal_variable.82908f68.svg";